import s from './fill-profile-card.module.scss'
import { NavLink } from 'react-router-dom'
import { IconChevronRight, IconInfoCircle, IconSquare, IconSquareCheckFilled } from '@tabler/icons-react';
import classNames from 'classnames';
import useMedia from 'use-media';
import { Loader } from '@shared/ui/loader/loader';
import { useEditScheduleModal } from '@features/teacher/edit-schedule/model/use-edit-schedule-modal';
import { Button } from '@shared/ui/button/button';
import { Modal } from '@shared/ui/modal/modal';
import { useState } from 'react';
import { getCDNPath } from '@utils/lib/getCDNpath';

export const FillProfileCard = ({profile, isTimeslotsLoading, timeslots, filled}) => {
	const isMobile = useMedia({maxWidth: '768px'})
	const {open: openModal} = useEditScheduleModal()
	const [isHelpOpen, setIsHelpOpen] = useState(false)

	const lineWidth = (number, max) => {
		return (number / max)*100
	}

	const items = [
		{
			done: !!(profile?.name && profile?.teacher_bio && profile?.avatar?.image),
			label: 'Заполнить профиль',
			link: '/settings',
		},
		{
			done: !!profile?.signed_docs,
			label: 'Подписать договор',
			link: '/settings',
			state: { section: 'offer' },
		},
		{
			done: timeslots?.length > 0,
			label: 'Настроить расписание',
			action: openModal,
		},
		{
			done: !!profile?.card_id,
			label: 'Привязать карту для выплат',
			link: '/settings',
		},
	]

	return (
		<div className={s.card}>
			<div className={s.content}>
				<div className={s.header}>
					<h2 className={s.title}>Завершите настройку профиля</h2>
					<button className={s.infoBtn} onClick={() => setIsHelpOpen(true)} title="Что нужно заполнить?">
						<IconInfoCircle size={20} />
					</button>
				</div>
				{isTimeslotsLoading ? <Loader/> : (
					<>
						<div className={s.progress}>
							<span className={s.progressNumber}>{filled}<span className={s.progressTotal}>/4</span></span>
							<div className={s.progressLine}>
								<span style={{width: lineWidth(filled, 4) + '%'}}></span>
							</div>
						</div>
						<div className={s.checkList}>
							{items.map(({done, label, link, action, state}, index) => (
								<div className={classNames(s.checkListItem, done && s.active)} key={index}>
									{done ? <IconSquareCheckFilled className={classNames(s.checkListIcon, s.active)} size={16}/> : <IconSquare className={s.checkListIcon} size={16}/>}
									{link ? (
										<NavLink to={link} state={state} className={s.checkListText}>{label}</NavLink>
									) : action ? (
										<button onClick={action} className={s.checkListText}>{label}</button>
									) : (
										<span className={s.checkListText}>{label}</span>
									)}
								</div>
							))}
						</div>
						<Button className={s.button} label={'Перейти в настройки'} rightIcon={<IconChevronRight size={16}/>} to={'/settings'}/>
					</>
				)}
			</div>
			{!isMobile && <img className={s.mascot} src={getCDNPath('images/mascot/man-mechanics.webp')} alt="" onError={(e) => { e.target.style.display = 'none'; }} />}
			<Modal isOpen={isHelpOpen} close={() => setIsHelpOpen(false)} title="Что нужно заполнить в профиле?" style={{content:{maxWidth: 480}}}>
				<div className={s.helpContent}>
					<br/>
					<p>Чтобы начать преподавать на платформе, заполните четыре обязательных пункта:</p>
					<ol>
						<li><strong>Заполните профиль</strong> — добавьте имя, фото и информацию о себе.</li>
						<li><strong>Подпишите договор-оферту</strong> — необходим для работы с платными занятиями.</li>
						<li><strong>Укажите расписание</strong> — выберите удобное время для занятий.</li>
						<li><strong>Привяжите карту для выплат</strong> — чтобы получать деньги за проведённые уроки.</li>
					</ol>
				</div>
			</Modal>
		</div>
	)
}
